module.exports = __webpack_public_path__ + "img/logo.15ae1334.png";